import {Trans} from 'react-i18next';

export const Or = () => {
  return (
    <div className="relative flex w-[35%] items-center justify-center">
      <div className="absolute left-0 top-0 flex h-full w-full items-center opacity-20 light:opacity-100">
        <div className="absolute flex h-px w-[35%] bg-neutral-80" />

        <div className="absolute right-0 flex h-px w-[35%] bg-neutral-80" />
      </div>

      <span className="relative px-2.5 text-base font-medium text-white opacity-60 light:text-neutral-500 light:opacity-100">
        <Trans i18nKey="misc.or" />
      </span>
    </div>
  );
};
